/* सरुवा व्यवस्थापन प्रणाली — custom.js v6
   Performance optimised | AdminLTE 3.2 compatible */

/* ── PAGE LOADER — Native JS, runs immediately ── */
(function () {
  function hideLoader() {
    var el = document.querySelector('.page-loader');
    if (!el) return;
    el.style.transition = 'opacity .4s';
    el.style.opacity    = '0';
    el.style.pointerEvents = 'none';
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 420);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(hideLoader, 300); });
  } else {
    setTimeout(hideLoader, 300);
  }
  setTimeout(hideLoader, 2000); // safety
})();

/* ── LIVE CLOCK — Native JS ── */
(function () {
  function pad(v) { return String(v).padStart(2, '0'); }
  function tick() {
    var n = new Date();
    var t = pad(n.getHours()) + ':' + pad(n.getMinutes()) + ':' + pad(n.getSeconds());
    document.querySelectorAll('.live-clock').forEach(function (el) { el.textContent = t; });
  }
  tick();
  setInterval(tick, 1000);
})();

/* ── jQuery-dependent features ── */
(function waitForJQuery() {
  if (typeof $ === 'undefined') { return setTimeout(waitForJQuery, 50); }

  $(function () {

    /* ── SMOOTH SCROLL ── */
    $(document).on('click', 'a[href^="#"]', function (e) {
      var $t = $(this.getAttribute('href'));
      if ($t.length) { e.preventDefault(); $('html,body').animate({ scrollTop: $t.offset().top - 70 }, 500); }
    });

    /* ── OTP INPUTS ── */
    var $oi = $('.otp-input');
    if ($oi.length) {
      $oi.on('input', function () {
        var v = $(this).val().replace(/\D/g, '').slice(0, 1);
        $(this).val(v);
        v ? $(this).addClass('filled').nextAll('.otp-input').first().focus()
          : $(this).removeClass('filled');
        _chkOtp();
      }).on('keydown', function (e) {
        if (e.key === 'Backspace' && !$(this).val()) {
          $(this).prevAll('.otp-input').first().focus().val('').removeClass('filled');
          _chkOtp();
        }
      }).on('paste', function (e) {
        e.preventDefault();
        var p = (e.originalEvent.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6);
        $oi.each(function (i) { $(this).val(p[i] || ''); p[i] ? $(this).addClass('filled') : $(this).removeClass('filled'); });
        _chkOtp();
      });
    }

    function _chkOtp() {
      var ok = true;
      $('.otp-input').each(function () { if (!$(this).val()) ok = false; });
      $('#verify-btn').prop('disabled', !ok);
    }

    /* ── OTP COUNTDOWN ── */
    if ($('#otp-timer').length) {
      function pad2(v) { return String(v).padStart(2, '0'); }
      var TOTAL = 120, left = TOTAL;
      var iv = setInterval(function () {
        left--;
        $('#otp-timer').text(Math.floor(left / 60) + ':' + pad2(left % 60));
        $('#timer-bar').css('width', (left / TOTAL * 100) + '%');
        if (left <= 30) { $('#otp-timer').addClass('text-danger').removeClass('text-muted'); $('#timer-bar').removeClass('bg-primary').addClass('bg-danger'); }
        if (left <= 0) {
          clearInterval(iv);
          $('#otp-timer').text('समय सकियो');
          $('#resend-otp').removeClass('disabled text-muted').css('pointer-events', 'auto').addClass('text-primary font-weight-bold');
        }
      }, 1000);

      $('#resend-otp').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        clearInterval(iv); left = TOTAL;
        $(this).addClass('disabled text-muted').css('pointer-events', 'none').removeClass('text-primary font-weight-bold');
        $('#otp-timer').removeClass('text-danger').addClass('text-muted');
        $('#timer-bar').css({ width: '100%' }).removeClass('bg-danger').addClass('bg-primary');
        $('.otp-input').val('').removeClass('filled').first().focus();
        $('#verify-btn').prop('disabled', true);
        toast('नयाँ OTP तपाईंको इमेलमा पठाइएको छ।', 'success');
        // restart
        iv = setInterval(arguments.callee.bind(this), 1000); // restart same fn pattern
      });
    }

    /* ── CUSTOM FILE LABEL ── */
    $(document).on('change', '.custom-file-input', function () {
      var f = this.files;
      $(this).next('.custom-file-label').text(f.length > 1 ? f.length + ' फाइलहरू छानिए' : (f[0] ? f[0].name : 'फाइल छान्नुहोस्'));
    });

    /* ── PASSWORD TOGGLE ── */
    $(document).on('click', '.pw-toggle', function () {
      var $i = $($(this).data('target'));
      $i.attr('type', $i.attr('type') === 'password' ? 'text' : 'password');
      $(this).find('i').toggleClass('fa-eye fa-eye-slash');
    });

    /* ── PASSWORD STRENGTH METER ── */
    $(document).on('input', '.pw-strength-input', function () {
      var v = $(this).val();
      var score = 0;
      if (v.length >= 8) score++;
      if (/[A-Z]/.test(v)) score++;
      if (/[0-9]/.test(v)) score++;
      if (/[^A-Za-z0-9]/.test(v)) score++;
      var map = [
        { w: '0%',   c: 'transparent',       t: '' },
        { w: '25%',  c: '#dc2626',           t: 'कमजोर' },
        { w: '50%',  c: '#d97706',           t: 'ठीकठाक' },
        { w: '75%',  c: '#2563eb',           t: 'राम्रो' },
        { w: '100%', c: '#16a34a',           t: 'उत्कृष्ट' },
      ];
      var m = map[score];
      var $wrap = $(this).closest('.form-group, .pw-strength-wrap');
      $wrap.find('.pw-strength-fill').css({ width: m.w, background: m.c });
      $wrap.find('.pw-strength-text').text(m.t).css('color', m.c);
    });

    /* ── ACTIVE SIDEBAR LINK ── */
    var pg = location.pathname.split('/').pop() || 'index.html';
    $('.nav-sidebar .nav-link').each(function () {
      if (($(this).attr('href') || '').split('/').pop() === pg) $(this).addClass('active');
    });

    /* ── TOOLTIPS ── */
    $('[data-toggle="tooltip"]').tooltip({ container: 'body' });

    /* ── TOAST SYSTEM ── */
    if (!$('#toast-wrap').length) $('body').append('<div id="toast-wrap"></div>');
    window.toast = function (msg, type) {
      var m = {
        success: { i: 'fa-circle-check',        c: '#16a34a' },
        danger:  { i: 'fa-circle-xmark',         c: '#dc2626' },
        warning: { i: 'fa-triangle-exclamation', c: '#d97706' },
        info:    { i: 'fa-circle-info',          c: '#2563eb' }
      };
      var cfg = m[type || 'info'] || m.info;
      var $t = $('<div class="toast-msg" style="border-left:4px solid ' + cfg.c + '">' +
        '<i class="fas ' + cfg.i + '" style="color:' + cfg.c + ';font-size:1rem;flex-shrink:0;margin-top:1px;"></i>' +
        '<span style="flex:1;font-size:.875rem;font-weight:500;color:#1e293b;">' + msg + '</span>' +
        '<i class="fas fa-xmark t-close" onclick="$(this).closest(\'.toast-msg\').remove()"></i>' +
        '</div>');
      $('#toast-wrap').append($t);
      setTimeout(function () {
        $t.css({ transition: 'all .3s', opacity: 0, transform: 'translateX(50px)' });
        setTimeout(function () { $t.remove(); }, 320);
      }, 3800);
    };

  });
})();
